<template>
  <v-row>
    <v-col cols="12">
      <template v-if="isGenerated">
        <v-card outlined>
          <v-card-text>
            <h1><v-icon>mdi-chart-bar</v-icon> Purchase Report</h1>
            <v-row class="mt-5 ">
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="purchaseFrom.duration"
                  :items="durations"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Duration"
                  dense
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="purchaseFrom.way"
                  :items="methods"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Method"
                  dense
                />
              </v-col>
              <template v-if="purchaseFrom.duration === 'period'">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="purchaseFrom.fromDate"
                    hide-details="auto"
                    label="Start Date"
                    outlined
                    dense
                    type="date"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="purchaseFrom.endDate"
                    hide-details="auto"
                    label="End Date"
                    outlined
                    type="date"
                    dense
                  />
                </v-col>
              </template>
              <v-col
                cols="12"
                md="4"
                sm="12"
                class="pl-3"
              >
                <v-btn
                  class="info"
                  @click="generateReport"
                >
                  Generate
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <template v-else>
        <div class="d-print-none text-right">
          <v-btn
            icon
            class="info--text"
            @click="printPurchaseReport"
          >
            <v-icon>mdi-printer</v-icon>
          </v-btn>
          <v-btn
            icon
            class="warning--text"
            @click="clear"
          >
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </div>
        <div class="pb-0 pt-0">
          <h3>
            PURCHASE REPORT : ( Duration:
            {{ purchaseFrom.duration | uppercase }}
            <template v-if="purchaseFrom.duration == 'period'">
              {{ purchaseFrom.fromDate }} to {{ purchaseFrom.endDate }}
            </template>
            )
          </h3>
          <h4>Generated At : {{ reference.time }}</h4>
          <h4>Generated By : {{ reference.by }}</h4>
          <img
            :src="reference.barcode"
            class="white pa-1"
          >
        </div>

        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                Purchases
              </th>
              <th class="text-left">
                Items Purchased
              </th>
              <th class="text-left">
                Total Cost
              </th>
              <th class="text-left">
                Tax Amount
              </th>
              <th class="text-left">
                Discount Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="active">
              <td>{{ purchaseReport.orders }}</td>
              <td>{{ purchaseReport.purchased }}</td>
              <td>{{ purchaseReport.costAmount }}</td>
              <td>{{ purchaseReport.tax | currency }}</td>
              <td>{{ purchaseReport.discount | currency }}</td>
            </tr>
          </tbody>
        </table>
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                TRX #
              </th>
              <th class="text-left">
                Date
              </th>
              <th class="text-left">
                Items
              </th>
              <th class="text-left">
                Net Cost
              </th>
              <th class="text-left">
                Tax
              </th>
              <th class="text-left">
                Discount
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="purchase in purchaseReport.list"
              :key="purchase.id"
            >
              <td>
                <img
                  :src="purchase.barcode"
                  class="purchaseBarcode white pa-1"
                >
              </td>
              <td>{{ purchase.created_at }}</td>
              <td>{{ purchase.totalItems }}</td>
              <td>{{ purchase.subTotal | currency }}</td>
              <td>
                {{ purchase.taxRate }}% | {{ purchase.taxAmount | currency }}
              </td>
              <td>
                {{ purchase.discountRate }}% |
                {{ purchase.discountedAmount | currency }}
              </td>
              <td>{{ purchase.totalAmount | currency }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      isGenerated: true,
      durations: [
        { name: "Today's Purchase", value: "today" },
        { name: "This Month Purchase", value: "monthly" },
        { name: "This Year Purchase", value: "yearly" },
        { name: "Specified Period", value: "period" },
      ],
      methods: [
        { name: "Live", value: 1 },
        { name: "Due", value: 0 },
      ],
      purchaseFrom: {
        duration: "yearly",
        way: 0,
      },
      purchaseReport: {},
      reference: {},
    };
  },
  methods: {
    clear() {
      Event.$emit("showDrawer");
      this.$data.isGenerated = true;
    },
    printPurchaseReport() {
      Event.$emit("hideDrawer");
      setTimeout(() => {
        window.print();
      }, 500);
    },
    generateReport() {
      window.axios
        .post("/purchase-report", this.purchaseFrom)
        .then((response) => {
          this.$data.purchaseReport = response.data;
          this.$data.reference = response.data.ref;
          this.$data.isGenerated = false;
        });
    },
  },
};
</script>

<style type="text/css">
.purchaseBarcode {
  width: 100px;
  height: 20px;
}
</style>
